// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1206":"76ab221b","1562":"692bc187","9519":"692bc187"}[chunkId] + ".chunk.css";
};